import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {UiComponentsModule} from '../../../shared-module-ui/ui-components.module';
import {DEFAULT_LOADER_FLASH, ISharedLoadingG} from '../../../shared-module-ui/models/animations';
import {IModalRef, ModalControllerService} from '../../../shared-services/overlay/modal-controller.service';

@Component({
  selector: 'app-shared-overlay-loading-modal',
  templateUrl: './shared-overlay-loading-modal.component.html',
  styleUrls: ['./shared-overlay-loading-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [UiComponentsModule],
})
export class SharedOverlayLoadingModalComponent {

  @Input() message = 'Loading…';

  protected readonly animation: Readonly<ISharedLoadingG> = DEFAULT_LOADER_FLASH;
}

/**
 * Opens the shared overlay loading modal and returns its reference so the caller can dismiss it.
 */
export async function presentSharedOverlayLoadingModal(
  modalController: ModalControllerService,
  message: string,
): Promise<IModalRef> {
  const loadingModal = await modalController.create({
    component: SharedOverlayLoadingModalComponent,
    componentProps: {message},
    cssClass: ['shared-overlay-loading-modal-css'],
    backdropDismiss: false,
  });
  await loadingModal.present();
  return loadingModal;
}
